<template>
  <kst-page-print pageFooter
    v-slot="{ title }"
    :catalog="RccdSearchCatalog"
    :params="Model.UrlParams"
    :search="searchData"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <List class="mt-4" :dataList="dataList"/>
  </kst-page-print>
</template>

<script>
import Model from "../RccdModel.js";
import RccdSearchCatalog from "../RccdSearchCatalog.js";
import Services from "../../../services/Api/RecCardServices.js";

import List from "./RccdP_List.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    List,
    Company
  },
  data: () => ({
    RccdSearchCatalog: RccdSearchCatalog,
    Model: Model,
    companyData: {},
    dataList: [],
    searchData: {
      TransactionDate: null,
      ClientID: null,
      ClientName: null,
      TypeID: null,
      WarehouseID: null
    }
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadPrint) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getPrintData(options);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.companyData = data.CompanyDetails;
      this.dataList = data.List;

      Model.updateList(this.dataList);
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.dataList = [];
    },
    resetSearch() {
      this.searchData.TransactionDate = this.$kst.In.getDefaultDateRange();
      this.searchData.ClientID = null;
      this.searchData.ClientName = null;
      this.searchData.TypeID = this.$kst.Search.OptionAll;
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
    },
    getListOptions() {
      const clientId = this.$kst.Out.getInteger(this.searchData.ClientID);
      const clientName = clientId === null
        ? this.$kst.Out.getString(this.searchData.ClientName) : null;

      return {
        client: clientId,
        clientname: clientName,
        type: this.$kst.Search.getValue(this.searchData.TypeID),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        startdate: this.$kst.Out.getDateString(this.searchData.TransactionDate[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.TransactionDate[1])
      };
    }
  }
}
</script>